/**
 * The per-pool notifications screen is a panel inside the pool screen's
 * Settings tab: `?poolId=<id>&tab=settings&panel=notifications`. It used to
 * be `?view=notifications`, and `aliasLegacyPoolView` keeps every link that
 * still carries that address resolving here (ISSUE-952 R6).
 *
 * Every screen and every navigation reads and writes this URL state through
 * the four functions below, never through `search.tab` or `search.panel`
 * directly.
 *
 * `apps/app/src/features/poolScreen/PoolSettingsTabPane.tsx` and
 * `PoolHomeNotificationsCard.tsx` are its only callers.
 */
import {
  openPoolTabSearch,
  readPoolTab,
  type typePoolTab,
} from "../poolScreen/poolScreenRoute";

export const POOL_NOTIFICATIONS_TAB: typePoolTab = "settings";

export const POOL_NOTIFICATIONS_PANEL = "notifications";

export function isPoolNotificationsOpen(search: {
  poolId?: string | undefined;
  tab?: string | undefined;
  panel?: string | undefined;
}): boolean {
  return (
    search.panel === POOL_NOTIFICATIONS_PANEL &&
    readPoolTab(search) === POOL_NOTIFICATIONS_TAB &&
    typeof search.poolId === "string" &&
    search.poolId !== ""
  );
}

export function openPoolNotificationsSearch<
  TSearch extends Record<string, unknown>,
>(
  search: TSearch,
): TSearch & { tab: typePoolTab; panel: typeof POOL_NOTIFICATIONS_PANEL } {
  return {
    ...openPoolTabSearch(search, POOL_NOTIFICATIONS_TAB),
    panel: POOL_NOTIFICATIONS_PANEL,
  };
}

/** Back to the Settings tab the panel opened over, carrying no panel with it. */
export function closePoolNotificationsSearch<
  TSearch extends Record<string, unknown>,
>(search: TSearch): TSearch & { tab: typePoolTab } {
  return openPoolTabSearch(search, POOL_NOTIFICATIONS_TAB);
}
